import { useEffect, useState } from 'react';

import { ExcludeCountryRule, ServerCard } from '../../types';
import { checkArraysEquality } from './checkArraysEquality';
import { filterCardsByCountryCode } from './filterCardsByCountryCode';

type Props = {
  cards: ServerCard[];
  excludeCardCountryCodes: ExcludeCountryRule[];
};

export const useCardsInitialValidation = ({ cards, excludeCardCountryCodes }: Props) => {
  const [isValidationInProgress, setValidationInProgress] = useState(false);
  const [memoizedCards, setMemoizedCards] = useState<ServerCard[]>([]);
  const [validatedCards, setValidatedCards] = useState<ServerCard[]>([]);

  useEffect(() => {
    (async () => {
      if (checkArraysEquality(memoizedCards, cards)) {
        return;
      }

      setMemoizedCards(cards);
      setValidationInProgress(true);

      const validatedCardsList = await filterCardsByCountryCode({
        cards,
        excludeCardCountryCodes,
      });

      setValidatedCards(validatedCardsList || []);
      setValidationInProgress(false);
    })();
  }, [cards.length, memoizedCards, excludeCardCountryCodes]);

  return {
    isValidationInProgress,
    validatedCards,
  };
};
